import { db } from "../../mp-database"

export default async function fetchGroupRecord(groupId) {
  const groupCollections = ["districts", "schools", "educators", "classes"]
  let foundRecord
  for (let i = 0; i < groupCollections.length; i++) {
    if (!foundRecord) {
      const collection = groupCollections[i]
      /*eslint-disable */
      const record = await db
        .collection(collection)
        .doc(groupId)
        .get()
        .then(doc => {
          if (doc.exists) {
            let queryDoc = doc.data()

            if (!queryDoc.deleted) {
              return queryDoc
            }
          }
        })
      if (record) {
        let groupType
        if (collection === "districts") {
          groupType = "School District"
        }
        if (collection === "schools") {
          groupType = "School"
        }
        if (collection === "educators") {
          groupType = "Teacher"
        }
        if (collection === "classes") {
          groupType = "Class"
        }

        foundRecord = record
        foundRecord.groupType = groupType
      }
    }
  }
  return foundRecord
}
